import React from 'react'
import { EssentialsInfosProps } from './essentialsInfos'

const Tag = ({
  info,
  color,
  bgColor,
}: {
  info: string | null
  color: EssentialsInfosProps['color']
  bgColor: EssentialsInfosProps['bgColor']
}) => {
  if (!info || info === 'Non précisé') {
    return null
  }
  return (
    <p
      role="note"
      className={`text-sm border rounded-md px-3 py-1 text-${color} border-${color} bg-${bgColor}-50`}
    >
      {info}
    </p>
  )
}

export default Tag
